import React, { useRef, useState } from 'react';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { Upload } from 'lucide-react';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { ApiService } from '../utils/api';
import { useToast } from './Toast';

/** Lets an admin attach a named document the attendee forgot to upload. */
const AddRegistrationDocument = ({ eventId, userId }) => {
  const [name, setName] = useState('');
  const [file, setFile] = useState(null);
  const fileInputRef = useRef(null);
  const { showSuccess, showError } = useToast();
  const queryClient = useQueryClient();

  const uploadMutation = useMutation({
    mutationFn: () => ApiService.uploadRegistrationDocument(eventId, userId, name.trim(), file),
    onSuccess: () => {
      showSuccess('Document added');
      setName('');
      setFile(null);
      if (fileInputRef.current) fileInputRef.current.value = '';
      queryClient.invalidateQueries({ queryKey: ['registration', eventId, userId] });
    },
    onError: (error) => showError(error.message || 'Failed to add document'),
  });

  return (
    <form
      className="flex flex-col md:flex-row gap-2 md:items-center"
      onSubmit={(e) => {
        e.preventDefault();
        if (name.trim() && file) uploadMutation.mutate();
      }}
    >
      <Input
        placeholder="Document name, e.g. ID proof"
        value={name}
        maxLength={60}
        onChange={(e) => setName(e.target.value)}
        className="md:w-64"
      />
      <input
        ref={fileInputRef}
        type="file"
        accept="image/*,application/pdf"
        className="text-sm"
        onChange={(e) => setFile(e.target.files?.[0] || null)}
      />
      <Button type="submit" size="sm" disabled={!name.trim() || !file || uploadMutation.isPending}>
        <Upload className="w-4 h-4 mr-1" />
        {uploadMutation.isPending ? 'Uploading…' : 'Add document'}
      </Button>
    </form>
  );
};

export default AddRegistrationDocument;
